import { ReviewedCartApiResponse } from "@swiggy-private/cart-types";
import { VALID_RENDERING_DETAILS_TYPE } from "@swiggy-private/cart-ui";
import { isEmpty } from "@swiggy-private/js-utils";

export const getDefaultTipDetails = (
    cartResponse?: ReviewedCartApiResponse | null,
): { amount: number; optIn: boolean } => {
    const defaultTipDetails = {
        amount: 0,
        optIn: true,
    };

    if (!cartResponse || !cartResponse.tipExperimentData || !cartResponse.tipExperimentData.tipOptions)
        return defaultTipDetails;

    const tipOptions = cartResponse.tipExperimentData.tipOptions;
    if (tipOptions && tipOptions.length > 0) {
        defaultTipDetails.amount = tipOptions[0].amount;
    }
    defaultTipDetails.optIn = true;
    return defaultTipDetails;
};

export const isTipDetailsExist = (cartResponse?: ReviewedCartApiResponse | null): boolean => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { rendering_details = [], tipDetails, tipExperimentData } = cartResponse ?? {};
    const isTipInRenderingDetails = rendering_details?.some(
        details => details.type.toUpperCase() === VALID_RENDERING_DETAILS_TYPE.CARD_INFORMATION,
    );

    return !!isTipInRenderingDetails && !isEmpty(tipDetails) && !isEmpty(tipExperimentData);
};
